/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JsonNode } from './JsonNode';
import {
    JsonNodeFromJSON,
    JsonNodeFromJSONTyped,
    JsonNodeToJSON,
    JsonNodeToJSONTyped,
} from './JsonNode';

/**
 * 
 * @export
 * @interface UpdateUserSettingRequest
 */
export interface UpdateUserSettingRequest {
    /**
     * 
     * @type {JsonNode}
     * @memberof UpdateUserSettingRequest
     */
    value: JsonNode | null;
}

/**
 * Check if a given object implements the UpdateUserSettingRequest interface.
 */
export function instanceOfUpdateUserSettingRequest(value: object): value is UpdateUserSettingRequest {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UpdateUserSettingRequestFromJSON(json: any): UpdateUserSettingRequest {
    return UpdateUserSettingRequestFromJSONTyped(json, false);
}

export function UpdateUserSettingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserSettingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'value': JsonNodeFromJSON(json['value']),
    };
}

export function UpdateUserSettingRequestToJSON(json: any): UpdateUserSettingRequest {
    return UpdateUserSettingRequestToJSONTyped(json, false);
}

export function UpdateUserSettingRequestToJSONTyped(value?: UpdateUserSettingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': JsonNodeToJSON(value['value']),
    };
}

